import { render, staticRenderFns } from "./DVRVideoComponent.vue?vue&type=template&id=4ddb2dae&scoped=true&"
import script from "./DVRVideoComponent.vue?vue&type=script&lang=js&"
export * from "./DVRVideoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb2dae",
  null
  
)

export default component.exports